export default {
  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
  backgroundColor: 'rgba(0, 0, 0, 0)',
  textStyle: {
    fontSize: 11,
  },
  xAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#333333',
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: '#333333',
      },
    },
    axisLabel: {
      show: true,
      // Modified.by.KWShin.2026.10.29. 축 라벨은 테마와 상관없이 System Overview 차트의 모양(9px, 보통 굵기, #bbbbaa)으로 그린다.
      // 예전 값(11px, 굵게, #6b717d)은 라벨 모양을 직접 정하지 않은 차트(ALERT, 통계 등)에 쓰였고,
      // 테마를 바꾸면 라벨 모양을 직접 정한 차트에도 덮어써져 차트마다 모양이 달라졌다(components/chart/Chart.vue 의 테마 전환 참고).
      // color: '#6b717d',
      // fontWeight: 'bold',
      // fontSize: 11,
      color: '#bbbbaa',
      fontWeight: 'normal',
      fontSize: 9,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#2f2f2f',
        opacity: 0.3,
      },
    },
    splitArea: {
      show: true,
      areaStyle: {
        color: '#242424',
        opacity: 0.3,
      },
    },
  },
  yAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#333333',
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: '#333333',
      },
    },
    axisLabel: {
      show: true,
      // Modified.by.KWShin.2026.10.29. 축 라벨은 테마와 상관없이 System Overview 차트의 모양(9px, 보통 굵기, #bbbbaa)으로 그린다.
      // 예전 값(11px, 굵게, #6b717d)은 라벨 모양을 직접 정하지 않은 차트(ALERT, 통계 등)에 쓰였고,
      // 테마를 바꾸면 라벨 모양을 직접 정한 차트에도 덮어써져 차트마다 모양이 달라졌다(components/chart/Chart.vue 의 테마 전환 참고).
      // color: '#6b717d',
      // fontWeight: 'bold',
      // fontSize: 11,
      color: '#bbbbaa',
      fontWeight: 'normal',
      fontSize: 9,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#2f2f2f',
        opacity: 0.3,
      },
    },
    splitArea: {
      show: true,
      areaStyle: {
        color: '#242424',
        opacity: 0.3,
      },
    },
    nameTextStyle: {
      color: '#6b717d',
      fontWeight: 'bold',
    },
  },
  tooltip: {
    textStyle: {
      fontSize: 11,
    },
  },
};
